<div *ngIf="invoice?.id" id="print-element">
  <div class="section-heading">
    <div align="right">
      <span class="label">Status:</span>
      <span class="result-field">{{(invoice.state ? invoice.state : 'Draft') | titlecase}}</span>
    </div>
    <div
      #buttons
      *ngIf="invoice?.id && ['OPEN', 'DRAFT', 'PARTIAL_CREDIT_MEMO'].includes((invoice?.state || '').toString().trim().toUpperCase())"
      class="text-right g-modal-buttons">
      <button mat-flat-button color="primary" (click)="createPaymentModal($event)">Checkout</button>
    </div>
  </div>

  <form #formElement="ngForm" *ngIf="formGroup" [formGroup]="formGroup">
    <div *ngIf="company" class="info d-flex">
      <div class="info-avatar pt-2 pr-3">
        <!-- Avatar -->
        <div class="avatar position-relative d-flex">
          <div *ngIf="company.logo; else noAvatar" class="has-avatar">
            <img [alt]="company.logo?.name"
                 [src]="company.logo?.filePath">
          </div>
          <ng-template #noAvatar>
            <div
              class="no-avatar text-center d-flex flex-column justify-content-center align-items-center">
              <img src="assets/images/logo.svg">
            </div>
          </ng-template>
        </div>
        <div class="company-data">
          <p class="title">Company Information</p>
          <hr>
          <div class="company-info">
            <div class="address">
              <div>
                <mat-icon svgIcon="map-pin"></mat-icon>
              </div>
              <div>
                <span *ngIf="company.addressOne" class="result-field">{{company.addressOne}}<br></span>
                <span *ngIf="company.addressTwo" class="result-field">{{company.addressTwo}}<br></span>
                <span *ngIf="company.city" class="result-field">{{company.city.name}}<br></span>
                <span *ngIf="company.state" class="result-field">{{company.state.name}}<br></span>
                <span *ngIf="company.country" class="result-field">{{company.country.name}}</span>
              </div>
            </div>
            <div class="name-label">
              <mat-icon svgIcon="phone"></mat-icon>
              <span *ngIf="company.phone" class="result-field">{{company.phone}}</span>
            </div>
            <div class="name-label">
              <mat-icon svgIcon="mail"></mat-icon>
              <span *ngIf="company.salesEmail" class="result-field">{{company.salesEmail}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="side-info">
        <div class="info-form-col">
          <div class="facility-invoice-info">
            <div class="input-wrap">
              <span class="label">Facility<br></span>
              <input [disabled]="true" [value]="facility?.primarySite?.legalBusinessName" id="name" matInput>
            </div>
            <div class="input-wrap facility-id">
              <span class="label">Facility ID <br></span>
              <input [disabled]="true" [value]="facility.id" matInput>
            </div>
            <div class="input-wrap invoice-number">
              <span class="label">Invoice number<br></span>
              <input [disabled]="true" [value]="invoice.number" matInput>
            </div>
          </div>
          <div class="dates">
            <div class="input-wrap date mt-2">
              <span class="label">Date<br></span>
              <input [matDatepicker]="picker" [required]="true" formControlName="date" id="date" matInput
              type="datetime" placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>

            <div class="input-wrap date mt-2">
              <span class="label">Due Date<br></span>
              <input [matDatepicker]="dueDatePicker" [required]="true" formControlName="dateDue" id="dueDate"
                     matInput type="datetime" placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle [for]="dueDatePicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </div>
          </div>

          <div class="facility-info">
            <p class="title">Facility Information</p>
            <hr>
            <div *ngIf="this.facility" class="facility-data">
              <div class="facility-data-left">
                <div *ngIf="this.facility?.primarySite?.partner?.name" class="facility-field">
                  <p class="label">Billing Contact Name:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.name}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.street1" class="facility-field">
                  <p class="label">Address Line 1:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.street1}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.street2" class="facility-field">
                  <p class="label">Address Line 2:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.street2}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.country && this.facility?.primarySite?.partner?.country?.id"
                     class="facility-field">
                  <p class="label">Country:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.country?.name}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.state && this.facility?.primarySite?.partner?.state?.id"
                     class="facility-field">
                  <p class="label">State:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.state?.name}}</p>
                </div>
              </div>
              <div class="facility-data-right">
                <div *ngIf="this.facility?.primarySite?.partner?.city" class="facility-field">
                  <p class="label">City:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.city}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.zipCode" class="facility-field">
                  <p class="label">Postal Code:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.zipCode}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.phone" class="facility-field">
                  <p class="label">Telephone Number:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.phone}}</p>
                </div>
                <div *ngIf="this.facility?.primarySite?.partner?.email" class="facility-field">
                  <p class="label">Email Address:</p>
                  <p class="result-field">{{this.facility?.primarySite?.partner?.email}}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="right-side">
          <div *ngIf="invoice.ref" class="facility-field">
            <p class="label right-label">Reference:</p>
            <p class="result-field">{{invoice.ref}}</p>
          </div>
          <div *ngIf="invoice.origin" class="facility-field">
            <p class="label right-label">Origin:</p>
            <p class="result-field">{{invoice.origin}}</p>
          </div>
        </div>
      </div>
    </div>


    <mat-table #table [dataSource]="dataSource" class="pt-3">

      <!--Product column-->
      <ng-container matColumnDef="product">
        <mat-header-cell *matHeaderCellDef style="width: 18% !important;"> Product</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;"
                  style="width: 18% !important;"
                  [matTooltip]="element.product.name"
                  matTooltipClass="custom-tooltip" matTooltipPosition="above"> {{element?.product?.name}} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef style="width: 18% !important;"> Description</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;" style="width: 18% !important;"
                  [matTooltip]="element.name"
                  matTooltipClass="custom-tooltip" matTooltipPosition="above"> {{element.name}} </mat-cell>
      </ng-container>

      <!-- Price column -->
      <ng-container matColumnDef="price">
        <mat-header-cell *matHeaderCellDef class="justify-right" style="width: 18% !important;"> Price</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;" style="width: 18% !important;"
                  class="justify-right"> {{element.price | number:'1.2-2'}}{{currencySymbolAfter}} </mat-cell>
      </ng-container>

      <!-- Total column -->
      <ng-container matColumnDef="amountTotalBeforeDiscount">
        <mat-header-cell *matHeaderCellDef class="justify-right" style="width: 18% !important;"> Total Before Discount</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;" style="width: 18% !important;"
                  class="justify-right"> {{element.amountTotalBeforeDiscount | number:'1.2-2'}}{{currencySymbolAfter}} </mat-cell>
      </ng-container>

      <!-- Discount column -->
      <ng-container matColumnDef="discount">
        <mat-header-cell *matHeaderCellDef class="justify-right" style="width: 18% !important;"> Discount</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;" style="width: 18% !important;"
                  class="justify-right"> {{element.amountTotalBeforeDiscount - element.amountTotal | number:'1.2-2'}}{{currencySymbolAfter}} </mat-cell>
      </ng-container>
      <!-- Total column -->
      <ng-container matColumnDef="amountTotal">
        <mat-header-cell *matHeaderCellDef class="justify-right"> Total</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index;"
                  class="justify-right"> {{element.amountTotal | number:'1.2-2'}}{{currencySymbolAfter}} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"></mat-row>
    </mat-table>

    <div class="price-section">
      <div>
        <p *ngIf="invoice?.origin">Refund description: </p>
        <p *ngIf="invoice?.origin" class="description">{{invoice?.description}}</p>
      </div>
      <div class="total">
        <div class="input-wrap" *ngIf="this.invoice?.discount">
          <span class="label">Discount<br></span>
          <input [disabled]="true" [value]="this.invoice?.discount.name" matInput>
        </div>
        <div>
          <p>Amount Before Discount:</p>
          <span> {{amountBeforeDiscount | number:'1.2-2'}}{{currencySymbolAfter}}</span>
        </div>
        <div>
          <p>Discount:</p>
          <span> {{amountBeforeDiscount - amountTotal | number:'1.2-2'}}{{currencySymbolAfter}}</span>
        </div>
        <div>
          <p>Amount total:</p>
          <span> {{amountTotal | number:'1.2-2'}}{{currencySymbolAfter}}</span>
        </div>
      </div>
    </div>
  </form>
</div>
